import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { useEffect, useState } from 'react'
import Loader from 'react-loaders'

const Terms = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <>
            <div className="container terms-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['T', 'e', 'r', 'm', 's', ' ', 'o', 'f', ' ', 'S', 'e', 'r', 'v', 'i', 'c', 'e']}
                            idx={15}
                        />
                    </h1>

                    <div className="terms-content">
                        <h3>VERMILION RESEARCH LLC</h3>
                        <p><strong>Effective Date:</strong> 6.7.2025 | <strong>Last Updated:</strong> 6.13.2025</p>

                        <h2>1. ACCEPTANCE OF TERMS</h2>
                        <p>By accessing or using any services, mobile applications, or products provided by Vermilion Research LLC ("Company," "we," "us," or "our"), you ("User" or "you") agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not use our services.</p>

                        <h2>2. DESCRIPTION OF SERVICES</h2>
                        <p>Vermilion Research LLC provides mobile applications, machine learning services, and robotics solutions. Our services may include:</p>
                        <ul>
                            <li>Mobile applications for data collection and analysis</li>
                            <li>Machine learning model development and training</li>
                            <li>Robotics software and hardware solutions</li>
                            <li>Related research and development services</li>
                        </ul>

                        <h2>3. USE OF SERVICES</h2>
                        <h3>3.1 Permitted Use</h3>
                        <p>You may use our services for lawful purposes only and in accordance with these Terms. You agree not to:</p>
                        <ul>
                            <li>Use our services for any illegal or unauthorized purpose</li>
                            <li>Interfere with or disrupt our services or servers</li>
                            <li>Attempt to gain unauthorized access to our systems</li>
                            <li>Reverse engineer, decompile, or disassemble our software</li>
                            <li>Use our services to transmit harmful, offensive, or inappropriate content</li>
                        </ul>

                        <h3>3.2 Data Collection and Use</h3>
                        <p>By using our services, you consent to our collection and use of certain data as described in our Privacy Policy. This may include location data, usage patterns, and other information necessary for machine learning model training and service improvement.</p>

                        <h2>4. INTELLECTUAL PROPERTY</h2>
                        <h3>4.1 Our Property</h3>
                        <p>All content, features, and functionality of our services, including but not limited to software, algorithms, text, graphics, logos, and trademarks, are owned by Vermilion Research LLC and are protected by intellectual property laws.</p>

                        <h3>4.2 User-Generated Content</h3>
                        <p>Any data, feedback, or content you provide through our services may be used by us for research, development, and improvement of our machine learning models and services.</p>

                        <h2>5. PRIVACY AND DATA SECURITY</h2>
                        <p>Your privacy is important to us. Please review our Privacy Policy, which explains how we collect, use, and protect your information when you use our services.</p>

                        <h2>6. DISCLAIMERS</h2>
                        <h3>6.1 Service Availability</h3>
                        <p>Our services are provided "as is" and "as available." We do not guarantee uninterrupted or error-free service.</p>

                        <h3>6.2 Machine Learning and AI</h3>
                        <p>Our machine learning models and AI systems are continuously improving but may not always provide perfect results. Users should exercise judgment when relying on outputs from our systems.</p>

                        <h2>7. LIMITATION OF LIABILITY</h2>
                        <p>To the maximum extent permitted by law, Vermilion Research LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of our services.</p>

                        <h2>8. INDEMNIFICATION</h2>
                        <p>You agree to indemnify and hold harmless Vermilion Research LLC from any claims, damages, losses, or expenses arising from your use of our services or violation of these Terms.</p>

                        <h2>9. TERMINATION</h2>
                        <p>We may terminate or suspend your access to our services at any time, with or without cause or notice.</p>

                        <h2>10. GOVERNING LAW</h2>
                        <p>These Terms are governed by the laws of the State of Illinois, without regard to conflict of law principles. Any disputes shall be resolved in the courts of Cook County, Illinois.</p>

                        <h2>11. CHANGES TO TERMS</h2>
                        <p>We reserve the right to modify these Terms at any time. Changes will be effective upon posting. Your continued use of our services after changes are posted constitutes acceptance of the modified Terms.</p>

                        <h2>12. CONTACT INFORMATION</h2>
                        <p>For questions about these Terms, please contact:</p>
                        <p>
                            <strong>Vermilion Research LLC</strong><br />
                            Chicago, IL<br />
                            <a href="mailto:info@vermresearch.com">info@vermresearch.com</a><br />
                            (312) 285-0552
                        </p>
                        <br /><br />
                    </div>
                </div>
            </div>
            <Loader type="ball-scale-multiple" />
        </>
    )
}

export default Terms
